export enum PhoneCodeEnum {
  DK = 45,
  SE = 46,
  FI = 358,
  NO = 47,
  DE = 49,
  GB = 44
}
